package com.example.crashbit

import androidx.compose.ui.geometry.Offset
import kotlinx.serialization.Serializable

@Serializable
data class WorldState(
    val bodies: List<SpaceBody>,
    val stars: List<SpaceBody>,
    val nebulae: List<Nebula> = emptyList(),
    val wormholes: List<Wormhole> = emptyList(),
    val scale: Float,
    @Serializable(with = OffsetSerializer::class)
    val pan: Offset = Offset.Zero,
    val isCrazyEddie: Boolean = false,
    val starsCanMerge: Boolean = true,
    val starsAreDynamic: Boolean = true,
    val planetsCanBeConsumed: Boolean = true,
    val auLimit: Float = 50f,
    val isPaused: Boolean = false
)

sealed class Screen {
    data object Onboarding : Screen()
    data object Title : Screen()
    data object About : Screen()
    data object Browser : Screen()
    data class Sandbox(val mode: GameMode, val savedName: String? = null) : Screen()
}

enum class GameMode {
    SINGLE,
    BINARY,
    CUSTOM,
    CRAZY_EDDIE,
    LOADED,
    STABLE_SYSTEM,
    WORM_VECTOR
}

enum class InputMode { OFF, YEET, RAIN }

enum class PlacementType { STAR, NEBULA, WORMHOLE }

enum class PlanetSize(val mass: Float, val radius: Float) {
    SMALL(10f, 10f), MEDIUM(50f, 20f), LARGE(200f, 35f)
}

data class SimulationFrame(
    val bodies: List<SpaceBody>,
    val stars: List<SpaceBody>,
    val stats: TelemetryStats,
    val displayStrings: TelemetryDisplayStrings, // V1.6: Pre-formatted for performance
    val scannerVersion: Int, // V2.6: Throttled HUD refresh
    val effects: List<VisualEffect>,
    val time: Long,
    val drawVersion: Int,
    val trajectories: OracleResult?,
    val interpolationAlpha: Float // V1.5.7: For smooth LERP rendering
)

data class TelemetryDisplayStrings(
    val speed: String = "0.0 km/s",
    val mass: String = "0T",
    val system: String = "0T"
)

data class TelemetryStats(
    val fastestSpeed: Float = 0f,
    val largestPlanetMass: Float = 0f,
    val totalSystemMass: Float = 0f,
    val starCount: Int = 0,
    val blackHoleCount: Int = 0,
    val fastestBodyId: Int = -1,
    val largestBodyId: Int = -1
)

data class ChangelogEntry(
    val version: String,
    val date: String,
    val highlights: List<String>
)

val defaultChangelogEntries = listOf(
    ChangelogEntry(
        version = "V4.4",
        date = "September 2026",
        highlights = listOf("Added Changelog and Developer Contact details.")
    )
)
